import { Button, SegmentedButton } from '@/components/DesignSystem';
import { DashboardProgramMode } from '@/pages/CustomerDashboard/Energy/useDashboardProgram';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

interface ProgramSwitchProps {
  memberships: { agronomy: boolean, energy: boolean },
  value: DashboardProgramMode,
}

export const ProgramSwitch = ({ memberships, value }: ProgramSwitchProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  if (!memberships.agronomy || !memberships.energy) {
    return null;
  }

  const select = (program: DashboardProgramMode) => {
    const next = new URLSearchParams(searchParams);
    next.set('program', program);
    setSearchParams(next);
  };

  return (
    <Stack data-testid="dashboard-program-switch" p="12px 16px">
      <SegmentedButton
        color="primary"
        fullWidth
        selectedIndex={value === 'agronomy' ? 0 : 1}
      >
        <Button
          aria-selected={value === 'agronomy'}
          key="agronomy"
          onClick={() => select('agronomy')}
          testID="dashboard-program-switch-agronomy"
        >
          {t(($) => $.customerDashboard.energy.switchAgronomy)}
        </Button>
        <Button
          aria-selected={value === 'energy'}
          key="energy"
          onClick={() => select('energy')}
          testID="dashboard-program-switch-energy"
        >
          {t(($) => $.customerDashboard.energy.switchEnergy)}
        </Button>
      </SegmentedButton>
    </Stack>
  );
};
